<template>
  <div class="assistant-feedback-wrapper mt-1">
    <button
      v-if="!showForm"
      class="feedback-trigger-btn"
      title="Flag issue & reconfigure prompt"
      @click="showForm = true"
    >
      <i class="mdi mdi-alert-circle-outline"></i>
      Reconfigure Prompt from Response
    </button>

    <div v-else class="feedback-card p-2 rounded bg-red-50 border border-red-200 mt-2">
      <div class="text-xs font-semibold text-red-700 mb-1 d-flex align-center justify-space-between">
        <span><i class="mdi mdi-auto-fix mr-1"></i> What was wrong with this response?</span>
        <i class="mdi mdi-close cursor-pointer" @click="showForm = false"></i>
      </div>
      <div class="text-caption text-gray-600 mb-2" style="font-size: 11px;">
        <strong>Assistant said:</strong> "{{ snippet }}"
      </div>
      <textarea
        v-model="userReason"
        class="feedback-textarea text-xs mb-2"
        rows="2"
        placeholder="e.g. The assistant gave the wrong pricing for consultation. It should state that consultations are $50."
      ></textarea>
      <div class="d-flex justify-end gap-2">
        <button class="btn-cancel text-xs px-2 py-1 rounded" @click="showForm = false">Cancel</button>
        <button
          class="btn-submit text-xs px-2 py-1 rounded bg-red-600 text-white font-medium"
          :disabled="loading || !userReason.trim()"
          @click="submitToTester"
        >
          <i v-if="loading" class="mdi mdi-loading mdi-spin mr-1"></i>
          Revise Prompt & Test
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AssistantMessageFeedback',
  props: {
    messageText: { type: String, required: true },
    phoneNumber: { type: String, default: '' },
    transcriptContext: { type: Array, default: () => [] },
    precedingUserMessage: { type: String, default: '' } // <-- Added prop
  },
  data() {
    return {
      showForm: false,
      userReason: '',
      loading: false
    }
  },
  computed: {
    snippet() {
      if (!this.messageText) return '';
      return this.messageText.length > 120 ? this.messageText.substring(0, 120) + '...' : this.messageText;
    }
  },
  methods: {
    async submitToTester() {
      this.loading = true;
      try {
        const payload = {
          bad_response: this.messageText,
          issue_description: this.userReason,
          phone_number: this.phoneNumber,
          context: this.transcriptContext,
          test_input: this.precedingUserMessage // <-- Send the prior user message here
        };
        
        const response = await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/agency/prompt-builder/revise`,
          payload,
          { headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt } }
        );

        if (response.data.success) {
          const promptData = {
            revised_prompt: response.data.revised_prompt,
            change_reason: this.userReason,
            // Fallback to response's test_input or the preceding user message if backend didn't return one
            test_input: response.data.test_input || this.precedingUserMessage || this.messageText,
            auto_test: 1
          };
          
          localStorage.setItem('pending_prompt_revision', JSON.stringify(promptData));

          this.$router.push({
            path: '/ai-agent',
            query: {
              phone: this.phoneNumber,
              pending_revision: 'true'
            }
          });
        } else {
          alert(response.data.error || 'Failed to reconfigure prompt');
        }
      } catch (e) {
        console.error(e);
        alert('Error connecting to prompt optimizer service.');
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.feedback-trigger-btn {
  font-size: 11px;
  color: #ef4444;
  background: transparent;
  border: 1px dashed #fca5a5;
  border-radius: 4px;
  padding: 2px 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}
.feedback-trigger-btn:hover {
  background: #fee2e2;
}
.feedback-textarea {
  width: 100%;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  padding: 6px;
  outline: none;
  background: #fff;
}
.btn-cancel {
  background: #e2e8f0;
  color: #475569;
  border: none;
}
</style>